import { Box } from "@mui/material";
import { styled } from "@mui/system";

const StyledBox = styled(Box)(({theme}) => ({
    background: '#6a6b6c',
    padding: '0.2em',
    color: '#ffffff',
    border: '2px solid #a2a3a4',
    borderRadius: '0.4em'
}));


export default function ICPNumberChip({icpNumber, ...props}) {
    return (
        <StyledBox component='span' {...props}>{icpNumber || ''}</StyledBox>
    )
}